import { Button, Stack, Typography } from '@mui/material';
import { FullPageWrapperForLoader } from './style';

type Props = {
  onRetry: () => void;
  onSignOut: () => void;
  retrying?: boolean;
};

/** Shown instead of the app when the data it cannot work without fails to load. */
const BootstrapError = ({ onRetry, onSignOut, retrying = false }: Props) => (
  <FullPageWrapperForLoader>
    <Stack spacing={2} alignItems='center' sx={{ maxWidth: 420, px: 2, textAlign: 'center' }}>
      <Stack role='alert' spacing={2}>
        <Typography variant='h6' component='h1'>
          We couldn&apos;t load the Provider App
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Check your connection and try again.
        </Typography>
      </Stack>
      <Stack direction='row' spacing={1}>
        <Button variant='contained' onClick={onRetry} disabled={retrying} autoFocus>
          {retrying ? 'Retrying…' : 'Retry'}
        </Button>
        <Button variant='text' onClick={onSignOut}>
          Sign out
        </Button>
      </Stack>
    </Stack>
  </FullPageWrapperForLoader>
);

export default BootstrapError;
